// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".aboshop-widget{flex-direction:column;border-radius:0px !important}.aboshop-widget svg{height:2.5rem;width:auto}.aboshop-widget a{padding-left:1rem;padding-right:1rem;font-family:Fira Sans Condensed, Rubik, Helvetica, Arial Narrow, Arial, sans-serif !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
